import { Message } from "./message";
import { Node } from "../node";
import { Settings } from "../settings/settings";


/**
 * The messaging system attached to each node. It handles the 
 * receiving, storing, and sending of messages across the network.
 */
export class SprayAndWait {

    public uniqueSentMessages: Array<Message> = [];
    public receivedMessages: Array<Message> = [];
    public droppedMessages: Array<Message> = [];

    // Messages currently stored in Node.
    public messages: Array<Message> = [];

    // Average number of nodes in range.
    public totalNodeContacts: number = 0;

    public nodeDegrees: Array<number> = [];
    public avgNodeDegree: number = 0;

    public totalSentMsgCount: number = 0;

    constructor(private nodeID: string, protected settings: Settings) {  }

    /**
     * Create k copies of given message and store it in the node.
     * @param message 
     */
    createNewMessage(message: Message): void {
        let numMsgCopies = this.settings.DEFAULT_MESSAGE_COPIES;

        // If this message is from an abacus, set this number of copies.
        if(message.abacus !== undefined) {
            numMsgCopies = message.abacus.numCopies;
        }

        this.uniqueSentMessages.push(message);

        console.log('>>>>>> CREATING ' + numMsgCopies + ' COPIES <<<<<')
        
        for(let i = 0; i < numMsgCopies; i++) {
            this.messages.push(message);
        }

        this.totalSentMsgCount += numMsgCopies;
    }

    /**
     * Take the message and destination, and spray half of the owned messages 
     * to the destination
     * @param messageToSpray 
     * @param destination 
     */
    sprayMessagesToDestination(destination: Node): void {
        // Get messages destined for the destination. If it has messages for the destination, it can
        // delete all copies of this destination after being sent.
        let messagesForDestination = this.getMessagesFor(destination);
        let uniqueMessagesForDestination = [... new Set(messagesForDestination)];
        destination.messagingSystem.receiveMessages(uniqueMessagesForDestination);
        this.messages = this.messages.filter( ( msg ) => !messagesForDestination.includes( msg ) );


        // All UNIQUE messages for destination
        let uniqueMessagesToSpray = [... new Set(this.messages)];

        uniqueMessagesToSpray.forEach((messageToSpray: Message) => {

            // If message has already been sent to the destination, skip it.
            if(messageToSpray.nodesAlreadyReceived.includes(destination)) {
                return;
            }

            // Get all of the messages that this node has which need to be sent.
            let allMsgsOfType = this.messages.filter((msg) =>  msg.id == messageToSpray.id);

            // If only 1 message left, don't send anything and wait to meet destination.
            if(allMsgsOfType.length == 1) return;

            // Calculate how many of these messages that need to be sent.
            let noMsgsToSend = Math.floor(allMsgsOfType.length / 2);

            // Get the actual messages to send to the next node.
            let msgsToSend = allMsgsOfType.slice(0, noMsgsToSend);

            // Remove all of the messages of the type being sent.
            this.messages = this.messages.filter((msg) => msg != messageToSpray);

            // Store that this message has alrwady been received by the receiving nodes, so 
            // it's not sent again erroneously.
            msgsToSend.map((msg) => msg.nodesAlreadyReceived.push(destination));

            // Add back half (half to be sent, half to remain.) 
            // @todo if there was an odd number, keep one more.
            this.messages = [...this.messages, ...msgsToSend];

            // Store this as the route the message took.
            msgsToSend.forEach((msg) => msg.routeTaken.push(destination));

            // Actually receive the message at the destination.
            destination.messagingSystem.receiveMessages(msgsToSend);
        });
    }

    /**
     * Given the array of messages, handle them.
     * if it is for this destination, destroy them 
     * if it's not for the desination, store them, ready to be sprayed when a new node is found.
     * @param messages 
     */
    receiveMessages(messages: Array<Message>) {

        // Get all messages destined for this node.
        let msgsForThisNode = messages.filter((msg) => {
            return msg.destination.id.toString() == this.nodeID;
        });

        let uniqueMsgsForThisNode: Array<Message> = [];

        // For each of the msgs for this node.
        msgsForThisNode.forEach((msgForThisNode: Message) => {
            // If more than one of the same message sent at the same time, skip the rest.
            if(uniqueMsgsForThisNode.filter(uniqueMsgForNode => uniqueMsgForNode.id == msgForThisNode.id).length > 0) return;

            // If message is already in the node, (sent at another time by another node), destroy message.
            if(this.receivedMessages.filter((receivedMessage: Message) => receivedMessage.id == msgForThisNode.id).length > 0) return;

            msgForThisNode.arrivalTime = Date.now();
            msgForThisNode.timeTakenToArrive = msgForThisNode.arrivalTime - msgForThisNode.creationTime;
            this.receivedMessages.push(msgForThisNode);
        });


        // Remove all messages for this node, the other messages need to be passed on.
        messages = messages.filter((msg) => {
            return msg.destination.id.toString() != this.nodeID;
        });

        // Store any messages not for this node, and wait to pass them on.
        this.messages = [... this.messages, ... messages];

        // If the node has too many messages, drop the latest
        if(this.messages.length > this.settings.MAX_NODE_CAPACITY) {
            this.droppedMessages = [...this.droppedMessages, ...this.messages.slice(this.settings.MAX_NODE_CAPACITY, this.messages.length)];
            this.messages = this.messages.slice(0, this.settings.MAX_NODE_CAPACITY);
            console.log('dropping ' + this.droppedMessages.length + ' messages');
        }
    }

    
    // Helper functions


    /**
     * Get all messages for the given node.
     * @param node 
     * @returns 
     */
    public getMessagesFor(node: Node) {
        return this.messages.filter((msg) => { 
            return msg.destination.id.toString() == node.id.toString(); 
        });
    }


}
